module.exports = __webpack_public_path__ + "static/img/icon-arrow-right.c5011920.svg";